(function () {
  if (window.__omGiftWidgetInitialized) return;
  window.__omGiftWidgetInitialized = true;

  const GIFT_SECTION_ID = 'cart-drawer';

  function getConfig() {
    const el = document.querySelector('cart-drawer-gift');
    if (!el) return null;
    return {
      country: el.getAttribute('data-country'),
      giftVariantId: parseInt(el.getAttribute('data-gift-variant-id'), 10),
    };
  }

  function getThreshold(country) {
    if (country === 'GB') return { amount: 250, symbol: '£' };
    if (country === 'US') return { amount: 250, symbol: '$' };
    return null; // UK/US only, by design
  }

  function toggleBlock(show) {
    const el = document.querySelector('cart-drawer-gift');
    if (el) el.classList.toggle('hidden', !show);
  }

  function toggleProgress(show) {
    const el = document.querySelector('cart-drawer-gift');
    const block = el?.querySelector('.om-gift-block');
    if (block) block.classList.toggle('hidden', !show);
  }

  function renderProgress(cartTotal, threshold) {
    const el = document.querySelector('cart-drawer-gift');
    const progressLine = el?.querySelector('.om-gift-block__item-progress');
    if (!progressLine) return;
    const remaining = Math.ceil(threshold.amount - cartTotal);
    progressLine.innerHTML =
      `spend <span>${threshold.symbol}${remaining}</span> more to unlock a complimentary perfume`;
  }

  let mutationLock = Promise.resolve();
  let giftMutationPending = false;
  function mutate(action) {
    giftMutationPending = true;
    const run = mutationLock.then(action).finally(() => {
      giftMutationPending = false;
    });
    mutationLock = run.catch(() => {});
    return run;
  }

  function applyDrawerHtml(html) {
    // Fallback only — used when Dawn's pub/sub system isn't available.
    // Prefer notifyCartUpdated() below, which lets Dawn's own
    // cart-drawer-items component redraw itself through the single
    // code path it already uses everywhere, instead of a second
    // implementation racing to replace the same node.
    const doc = new DOMParser().parseFromString(html, 'text/html');
    ['cart-drawer-items', '.cart-drawer__footer'].forEach((selector) => {
      const target = document.querySelector(selector);
      const source = doc.querySelector(selector);
      if (target && source) target.replaceWith(source);
    });
  }

  function notifyCartUpdated(data) {
    // Dawn's cart-drawer-items component subscribes to this exact
    // event (see cart.js) and re-renders itself via its own reliable
    // fetch + replaceWith when it fires with any source other than
    // 'cart-items'. Using it means our own gift mutation redraws the
    // drawer through the same single path Dawn's native remove/quantity
    // changes already use, instead of a second implementation that can
    // end up writing into a node Dawn's own in-flight update still
    // expects to find live.
    if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gift-widget', cartData: data });
      return;
    }
    // Pub/sub not available on this page for some reason — fall back
    // to our own direct replace using the section HTML requested
    // alongside the mutation.
    if (data.sections && data.sections[GIFT_SECTION_ID]) {
      applyDrawerHtml(data.sections[GIFT_SECTION_ID]);
    }
  }

  function addGift(variantId, isRetry) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: { '_free_gift': 'true' } }],
        sections: [GIFT_SECTION_ID],
      }),
    })
      .then((r) => r.text().then((text) => ({ ok: r.ok, status: r.status, text })))
      .then(({ ok, status, text }) => {
        let data;
        try { data = JSON.parse(text); } catch (e) { data = null; }
        if (!ok || data?.status) {
          console.warn(`[gift] add failed (HTTP ${status})`, data || text);
          consecutiveFailures += 1;
          if (consecutiveFailures >= 3) {
            circuitOpenUntil = Date.now() + 30000;
            console.error('[gift] repeated cart failures — pausing gift automation for 30s to avoid hammering the endpoint');
          } else if (!isRetry) {
            return new Promise((res) => setTimeout(res, 600)).then(() => addGift(variantId, true));
          }
          return;
        }
        consecutiveFailures = 0;
        if (data?.sections && data.sections[GIFT_SECTION_ID]) {
          notifyCartUpdated(data);
        }
      })
      .catch((err) => console.warn('[gift] add request error', err));
  }

  function setGiftQuantity(lineKey, quantity, isRetry) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity, sections: [GIFT_SECTION_ID] }),
    })
      .then((r) => r.text().then((text) => ({ ok: r.ok, status: r.status, text })))
      .then(({ ok, status, text }) => {
        let data;
        try { data = JSON.parse(text); } catch (e) { data = null; }
        if (!ok || data?.status) {
          console.warn(`[gift] quantity correction failed (HTTP ${status})`, data || text);
          consecutiveFailures += 1;
          if (consecutiveFailures >= 3) {
            circuitOpenUntil = Date.now() + 30000;
          } else if (!isRetry) {
            return new Promise((res) => setTimeout(res, 600)).then(() => setGiftQuantity(lineKey, quantity, true));
          }
          return;
        }
        consecutiveFailures = 0;
        if (data?.sections && data.sections[GIFT_SECTION_ID]) {
          notifyCartUpdated(data);
        }
      })
      .catch((err) => console.warn('[gift] quantity correction request error', err));
  }

  function removeGift(lineKey, isRetry) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0, sections: [GIFT_SECTION_ID] }),
    })
      .then((r) => r.text().then((text) => ({ ok: r.ok, status: r.status, text })))
      .then(({ ok, status, text }) => {
        let data;
        try { data = JSON.parse(text); } catch (e) { data = null; }
        if (!ok || data?.status) {
          console.warn(`[gift] remove failed (HTTP ${status})`, data || text);
          consecutiveFailures += 1;
          if (consecutiveFailures >= 3) {
            circuitOpenUntil = Date.now() + 30000;
            console.error('[gift] repeated cart failures — pausing gift automation for 30s to avoid hammering the endpoint');
          } else if (!isRetry) {
            return new Promise((res) => setTimeout(res, 600)).then(() => removeGift(lineKey, true));
          }
          return;
        }
        consecutiveFailures = 0;
        if (data?.sections && data.sections[GIFT_SECTION_ID]) {
          notifyCartUpdated(data);
        }
      })
      .catch((err) => console.warn('[gift] remove request error', err));
  }

  let consecutiveFailures = 0;
  let circuitOpenUntil = 0;

  function evaluate(cart) {
    const config = getConfig();
    if (!config) return;

    if (!Number.isFinite(config.giftVariantId)) {
      console.error('[gift] giftVariantId is not a valid number — refusing to mutate cart', config);
      return;
    }

    if (Date.now() < circuitOpenUntil) {
      return; // repeated failures — back off instead of hammering the endpoint
    }

    const threshold = getThreshold(config.country);

    if (!threshold) {
      toggleBlock(false);
      return;
    }

    if (cart.item_count === 0) {
      sessionStorage.removeItem('omGiftRemoved');
      toggleBlock(false);
      return;
    }

    toggleBlock(true);

    if (giftMutationPending) {
      // A decision to add/remove is already in flight from an earlier
      // check — skip acting again on what might be the same stale
      // snapshot. The next check (poll or DOM observer) will see the
      // settled state once this one completes.
      return;
    }

    const cartTotal = cart.total_price / 100;
    const giftLineItem = cart.items.find((item) => item.variant_id === config.giftVariantId);
    const giftInCart = !!giftLineItem;
    const eligible = cartTotal >= threshold.amount;
    const removedThisSession = sessionStorage.getItem('omGiftRemoved') === 'true';

    if (eligible && !giftInCart && !removedThisSession) {
      mutate(() => addGift(config.giftVariantId));
      return;
    }

    if (!eligible && giftInCart) {
      // Use the line item's key, not the bare variant ID — the gift
      // line carries a property (_free_gift), and once a line has
      // properties, Shopify's cart API needs the key (variant ID +
      // properties hash) to uniquely identify it. The variant ID
      // alone was being rejected with a 400.
      mutate(() => removeGift(giftLineItem.key));
      return;
    }

    if (eligible && giftInCart && giftLineItem.quantity > 1) {
      // Self-heal a duplicate created before the pending-mutation
      // guard existed — correct it back down to a single free unit
      // rather than leaving it silently wrong.
      mutate(() => setGiftQuantity(giftLineItem.key, 1));
      return;
    }

    if (!eligible && !giftInCart) {
      renderProgress(cartTotal, threshold);
      toggleProgress(true);
    } else {
      toggleProgress(false);
    }
  }

  let nativeActionCooldownUntil = 0;
  function isCoolingDown() {
    return Date.now() < nativeActionCooldownUntil;
  }
  // Any click on a remove button, or a change on a quantity input,
  // marks a window during which this script does nothing but wait —
  // it never fires its own cart request while a native interaction
  // could still be in flight, so the two mechanisms can't collide.
  document.addEventListener('click', function (e) {
    if (e.target.closest('cart-remove-button button')) {
      nativeActionCooldownUntil = Date.now() + 1500;
    }
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target.closest('.cart-item') && e.target.matches('input')) {
      nativeActionCooldownUntil = Date.now() + 1500;
    }
  }, true);

  let evalTimer = null;
  function scheduleEvaluate() {
    clearTimeout(evalTimer);
    evalTimer = setTimeout(runEvaluate, 150);
  }

  function runEvaluate() {
    if (isCoolingDown()) {
      scheduleEvaluate();
      return;
    }
    fetch('/cart.js').then((r) => r.json()).then(evaluate).catch(() => {});
  }

  // Watch for either the drawer's own items list (cart-drawer-items)
  // or the full cart page's items list (cart-items) being replaced —
  // both are separate components in Dawn, and a removal made on the
  // /cart page wouldn't touch cart-drawer-items at all, so watching
  // only that one meant gift removal never fired for that case.
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (
          node.matches?.('cart-drawer-items, cart-items') ||
          node.querySelector?.('cart-drawer-items, cart-items')
        ) {
          scheduleEvaluate();
          return;
        }
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', runEvaluate);
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    runEvaluate();
  }

  // Backup safety net: several attempts at catching the exact DOM
  // mutation that signals "the cart just changed" have each missed some
  // case in this theme's ecosystem (different cart components, other
  // apps re-rendering their own way). A plain poll can't miss anything,
  // regardless of what caused the change or which component handled it
  // — it costs a small amount of extra network chatter, but guarantees
  // the gift is never more than ~2s out of sync with the real cart.
  setInterval(runEvaluate, 2000);

  // Portal the modal to <body> once, so it's never subject to the
  // scrollable drawer container's overflow clipping. Runs whenever a
  // new <cart-drawer-gift> element appears (each drawer re-render
  // creates a fresh one).
  if (!customElements.get('cart-drawer-gift')) {
    class CartDrawerGift extends HTMLElement {
      connectedCallback() {
        const overlay = this.querySelector('#omGiftModalOverlay');
        if (!overlay) return;
        const existing = document.getElementById('omGiftModalOverlay');
        if (existing && existing !== overlay) {
          overlay.remove();
          return;
        }
        document.body.appendChild(overlay);
      }
    }
    customElements.define('cart-drawer-gift', CartDrawerGift);
  }

  // Info modal open/close — delegated so it works after any drawer re-render.
  document.addEventListener('click', function (e) {
    const infoBtn = e.target.closest('.om-gift-block__info-button');
    if (infoBtn) {
      const overlay = document.getElementById('omGiftModalOverlay');
      if (overlay) overlay.classList.remove('hidden');
      return;
    }

    const closeBtn = e.target.closest('.om-gift-block__modal-close');
    const overlay = e.target.closest('.om-gift-block__modal-overlay');
    if (closeBtn || (overlay && e.target === overlay)) {
      overlay?.classList.add('hidden');
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.om-gift-block__modal-overlay:not(.hidden)').forEach((overlay) => {
        overlay.classList.add('hidden');
      });
    }
  });

  // Mark the gift as manually removed for this session, so it doesn't
  // immediately re-add itself on the next cart refresh.
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('cart-remove-button button');
    if (btn && btn.closest('.cart-item')?.querySelector('.cart-item__gift-label')) {
      sessionStorage.setItem('omGiftRemoved', 'true');
    }
  }, true);
})();